// extracted by mini-css-extract-plugin
export const item = "item-module--item--1BNZG";
export const head = "item-module--head--2WH6t";
export const title = "item-module--title--1Jzkv";
export const lead = "item-module--lead--1l0Eq";
export const tag = "item-module--tag--tTgjV";